import { Outlet } from 'react-router-dom'
import BackgroundOrbs from './BackgroundOrbs'
import DFMHeader from './DFMHeader'
import DFMFooter from './DFMFooter'

export default function DFMLayout() {
  return (
    <div className="min-h-screen w-full flex flex-col">
      <BackgroundOrbs />
      <DFMHeader />
      <main className="flex-1 w-full relative z-[1]">
        <Outlet />
      </main>
      <DFMFooter />
    </div>
  )
}
